(() => {
  if (window.spotmateMobileLayout) return;
  window.spotmateMobileLayout = true;
  const init = () => {
    const layout = document.querySelector('.pdp-purchase-layout');
    if (!layout) return;
    const body = document.body;
    const media = matchMedia('(max-width:767px)');
    let previousY = scrollY;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const header = document.querySelector('store-header.header.kik-header');
      const tabs = document.querySelector('.kik-product-tab-categories');
      const main = layout.closest('.section-product-info');
      const buy = layout.querySelector('.x-block-buy-buttons');
      const inDetails = !!main && main.getBoundingClientRect().bottom <= (header?.offsetHeight || 0) + 48;
      const movement = scrollY - previousY;
      if (!media.matches || !inDetails) body.removeAttribute('data-pdp-reading');
      else if (movement > 4 && !header?.contains(document.activeElement)) body.dataset.pdpReading = 'true';
      else if (movement < -4) body.removeAttribute('data-pdp-reading');
      if (Math.abs(movement) > 4) previousY = scrollY;
      const headerVisible = header && header.getBoundingClientRect().bottom > 0;
      body.style.setProperty('--pdp-header-offset', body.dataset.pdpReading ? '0px' : `${headerVisible ? header.offsetHeight : 0}px`);
      body.toggleAttribute('data-pdp-primary-buy', media.matches && !!buy && buy.getBoundingClientRect().bottom > 0);
      const kitFooter = document.querySelector('.pdp-kit:not([hidden]) .pdp-kit__footer');
      const kitRect = kitFooter?.getBoundingClientRect();
      body.toggleAttribute('data-pdp-kit-buy', media.matches && !!kitRect && kitRect.top < innerHeight && kitRect.bottom > 0);
      if (!tabs) body.removeAttribute('data-pdp-reading');
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule);
    media.addEventListener('change', schedule);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
